/**
 * Subscription State Machine — Frontend Mirror (METALARK-789)
 *
 * ⚠️  AUTO-GENERATED FILE — DO NOT EDIT DIRECTLY
 *
 * Generated from api/services/SubscriptionStateMachine.ts.
 * Run 'npm run generate:state-machine' to regenerate after backend changes.
 *
 * Last generated: 2026-06-03T19:42:25.087Z
 */

/** All canonical stored states (mirrors SUBSCRIPTION_STATES). */
export const SUBSCRIPTION_STATES = [
    'TRIAL_ACTIVE',
    'TRIAL_EXPIRED',
    'ACTIVE',
    'ACTIVE_SCHEDULED_CANCEL',
    'PAYMENT_PENDING',
    'PAST_DUE',
    'INCOMPLETE',
    'CANCELED_IN_GRACE',
    'EXPIRED',
    'PENDING_DELETION',
    'SOFT_DELETED',
];

/**
 * Allowed transitions per state (mirrors ALLOWED_TRANSITIONS). Each key is a
 * stored state; each value is the array of states that state can transition
 * into via admin / sweep / customer actions. Stripe webhook actor bypasses
 * this map server-side.
 */
export const ALLOWED_TRANSITIONS = {
    'TRIAL_ACTIVE': ['ACTIVE', 'TRIAL_EXPIRED', 'CANCELED_IN_GRACE'],
    'TRIAL_EXPIRED': ['TRIAL_ACTIVE', 'ACTIVE', 'EXPIRED'],
    'ACTIVE': ['ACTIVE_SCHEDULED_CANCEL', 'PAST_DUE', 'CANCELED_IN_GRACE'],
    'ACTIVE_SCHEDULED_CANCEL': ['ACTIVE', 'CANCELED_IN_GRACE', 'PAST_DUE'],
    'PAYMENT_PENDING': ['ACTIVE', 'INCOMPLETE'],
    'PAST_DUE': ['ACTIVE', 'CANCELED_IN_GRACE', 'EXPIRED'],
    'INCOMPLETE': ['ACTIVE', 'EXPIRED'],
    'CANCELED_IN_GRACE': ['ACTIVE', 'EXPIRED'],
    'EXPIRED': ['CANCELED_IN_GRACE', 'ACTIVE', 'PENDING_DELETION'],
    'PENDING_DELETION': ['ACTIVE', 'SOFT_DELETED'],
    'SOFT_DELETED': ['ACTIVE'],
};

/**
 * Map of displayed-only states to their canonical stored state. Mirrors
 * toStoredState() in api/services/SubscriptionStateMachine.ts. Only the
 * states that are view-only modifiers (TRIAL_ENDING_SOON, UNPAID, PAUSED,
 * ACTIVE_PLAN_CHANGE_PENDING) appear here; stored states map to themselves
 * via toStoredState() below.
 */
export const DISPLAYED_TO_STORED = {
    'TRIAL_ENDING_SOON': 'TRIAL_ACTIVE',
    'UNPAID': 'PAST_DUE',
    'PAUSED': 'CANCELED_IN_GRACE',
    'NO_SUBSCRIPTION': null,
};

/** Type guard for the stored-state set. */
export function isSubscriptionState(value) {
    return typeof value === 'string' && SUBSCRIPTION_STATES.includes(value);
}

/**
 * Normalize a DisplayedSubscriptionState (which includes view-only
 * modifiers like TRIAL_ENDING_SOON) to its canonical stored state.
 * Returns null when the displayed value has no stored counterpart
 * (e.g. NO_SUBSCRIPTION). Used by the state-diagram component to
 * highlight the right node when the customer is on a displayed-only
 * pseudo-state.
 */
export function toStoredState(displayed) {
    if (displayed == null) return null;
    if (Object.prototype.hasOwnProperty.call(DISPLAYED_TO_STORED, displayed)) {
        return DISPLAYED_TO_STORED[displayed];
    }
    return isSubscriptionState(displayed) ? displayed : null;
}

/** Convenience: returns the allowed targets from a given state, or [] if unknown. */
export function allowedTransitionsFrom(fromState) {
    if (!fromState || !isSubscriptionState(fromState)) return [];
    return ALLOWED_TRANSITIONS[fromState] || [];
}
